import React, { Component } from "react";

import getDates from "../../../shared/services/date.service";
import styles from "./cmsHistory.module.scss";

class CmsHistoryCommentaryItem extends Component {
  render() {
    const { item } = this.props;

    return (
      <div className={styles.cmsHistoryCommentaryItem}>
        <div>
          <div>
            <b>{getDates.getDateFormat9(new Date(Date.parse(item.date)))}</b>
          </div>
          <div>Пользователь: {item.user.title}</div>
          <div>{item.user.email}</div>
        </div>
        <div>
          <span style={{ whiteSpace: "pre-line" }}>{item.commentary}</span>
        </div>
      </div>
    );
  }
}

export default CmsHistoryCommentaryItem;
